<template>
  <div>
    <div v-if="!categoryId">
      <v-btn @click="dialogOpen = true" class="orange">{{ $t("select") }}</v-btn>
    </div>

    <div v-else>
      <v-chip
        class="ma-2"
        :close="!readOnly"
        color="#F5F5F5"
        @click:close="selectHandler(null)"
      >{{ name }}</v-chip>
    </div>

    <custom-dialog
      v-if="dialogOpen"
      @close="dialogOpen = false"
      :title="$t('select_category')"
      hide-actions
    >
      <template v-slot:text>
        <v-list style="max-height: 50vh; overflow: auto">
          <div v-for="category in categoryOptions" :key="category.value">
            <v-list-item @click="selectHandler(category.value)">
              <v-list-item-content>{{ category.text }}</v-list-item-content>
            </v-list-item>
            <v-divider></v-divider>
          </div>
        </v-list>
      </template>
    </custom-dialog>
  </div>
</template>

<script>
import CustomDialog from "@/components/shared/CustomDialog.vue";

export default {
  components: { CustomDialog },
  props: {
    categoryId: {
      type: Number,
      default: null
    },
    readOnly: {
      type: Boolean,
      default: null
    }
  },
  data() {
    return {
      dialogOpen: false
    };
  },
  methods: {
    selectHandler(id) {
      this.dialogOpen = false;
      this.$emit("select", id);
    }
  },
  computed: {
    categoryOptions() {
      return this.$store.getters["Category/options"];
    },
    name() {
      const category = this.$store.state.Category.list[this.categoryId];

      return category && category.name;
    }
  }
};
</script>

<style scoped>
</style>
